export const getStringWithoutTags = (str?: string) =>
  str?.replace(/(<([^>]+)>)/gi, '') || ''

export const getCapitalizedString = (str: string) =>
  str[0].toUpperCase() + str.slice(1)
